<template>
        <div class="space-y-4">
          <h3 class="text-xl font-semibold">Доктора в клинике</h3>
          <div v-if="doctors.length === 0" class="text-gray-500">Докторов нет в этой клинике</div>
          <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div
              v-for="doctor in doctors"
              :key="doctor.ID"
              class="border rounded-lg p-4 bg-white shadow hover:shadow-lg transition"
            >
              <h4 class="text-lg font-medium">
                👨‍⚕️ {{ doctor.User.full_name }}
              </h4>
              <p class="text-gray-600 text-sm">Специальность: {{ doctor.speciality }}</p>
              <p class="text-gray-600 text-sm">Телефон: {{ doctor.User.phone }}</p>
              <p class="text-gray-600 text-sm">Возраст: {{ doctor.age }}</p>
              <p class="text-gray-600 text-sm">Описание: {{ doctor.describe }}</p>
              <p class="text-gray-600 text-sm">Образование: {{ doctor.knowledge }}</p>
              <p class="text-gray-600 text-sm">Курсы: {{ doctor.courses }}</p>
              <p class="text-gray-600 text-sm">Сертификаты: {{ doctor.certificates }}</p>
              <p class="text-gray-600 text-sm">Услуги: {{ doctor.services }}</p>
              <p class="text-gray-600 text-sm">Цена: {{ doctor.price }} KZT</p>
              <p class="text-gray-600 text-sm">Кабинет: №{{ doctor.cabinet }}</p>
            </div>
          </div>
        </div>
      </template>

      <script>
      export default {
        name: "DoctorList",
        props: {
          doctors: {
            type: Array,
            required: true,
            default: () => []
          }
        }
      };
      </script>

      <style scoped>
      </style>
